import axios, { AxiosError, AxiosRequestHeaders } from 'axios';
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';

// https://vitejs.dev/guide/env-and-mode.html
const API = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}`,
  timeout: 180000,
  headers: {
    'Content-Type': 'application/json',
  },
});

API.interceptors.request.use(async (request) => {
  try {
    if (!request.headers) {
      request.headers = {} as AxiosRequestHeaders;
    }
  } catch (err) {
    return request;
  }

  return request;
});

interface AxiosInterceptorProps {
  children: JSX.Element;
}

const AxiosInterceptor = ({ children }: AxiosInterceptorProps) => {
  useEffect(() => {
    const responseInterceptor = API.interceptors.response.use(
      async (response) => {
        return response;
      },
      async (error: AxiosError) => {
        if (error.response) {
          Sentry.captureException(error, { extra: { location: 'API INTERCEPTOR' } });
        }
        throw error;
      },
    );

    return () => {
      /**
       * we should eject previous interceptors in the clean up function, in case we do not
       * each time the useEffect is executed, the interceptor will be added to interceptors stack
       */
      return API.interceptors.response.eject(responseInterceptor);
    };
  }, []);
  return children;
};

export default API;
export { AxiosInterceptor };
